import op from "../dates/dates";

let date = new Date().getDate();
let month = op.months[new Date().getMonth()].short;

function getDateMonth() {
  return month + " " + date;
}

function getPrevDateMonth(diff) {
  console.log(diff);
  let dt = new Date();
  dt.setDate(dt.getDate() - diff);
  let date = new Date(dt).getDate();
  let month = op.months[new Date().getMonth()].short;
  console.log(month);
  return month + " " + date;
}

function getCategories(length){
  let cat =[];
  for (let index = 0; index < length; index++) {
    if(index===2){
      cat.push(getPrevDateMonth(length))
    }else if( index === length-1 ){
      cat.push(getDateMonth())
    }else{
      cat.push("");
    }
  }
  return cat;
}

const studGrowth = {
  colors: ["#009688", "#E91E63", "#9C27B0"],
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      opacityFrom: 0.8,
      opacityTo: 0,
      stops: [0, 100]
    }
  },
  grid: { show: false, borderColor: "#78909c" },
  chart: { foreColor: "#78909c", toolbar: { show: false } },
  dataLabels: { enabled: false },
  stroke: { curve: "smooth" },
  xaxis: {
    type: "text",
    categories: getCategories(30)
  },
  tooltip: { x: { format: "dd/MM/yy HH:mm" } }
};

const visitGrowth = {
  colors: ["#ec407a", "#E91E63", "#9C27B0"],
  fill: {
    type: "gradient",
    gradient: {
      shade: "dark",
      type: "vertical",
      opacityFrom: 0.8,
      opacityTo: 0,
      stops: [0, 100]
    }
  },
  grid: { show: false, borderColor: "#37474f" },
  chart: { foreColor: "#78909c", toolbar: { show: false } },
  dataLabels: { enabled: false },
  stroke: { curve: "smooth" },
  xaxis: {
    type: "text",
    categories: getCategories(30),
  },
  tooltip: { x: { format: "dd/MM/yy HH:mm" } }
};

const barOptions= {
  colors: ["#009688", "#263238", "#9C27B0"],
  grid: { show: true, borderColor: "#37474f" },
  chart: { foreColor: "#78909c", toolbar: { show: false } },
  plotOptions: {
    bar: {
      horizontal: true,
      dataLabels: {
        position: "top"
      }
    }
  },
  dataLabels: {
    enabled: true,
    offsetX: -6,
    style: {
      fontSize: "12px",
      colors: ["#fff"]
    }
  },
  stroke: {
    show: false,
    width: 1,
    colors: ["#fff"]
  },

  xaxis: {
    categories: ["v month", "s/a month", "v year", "s/a week"]
  }
};

const radialBar = {
  chart: {
    height: 300,
    type: "radialBar"
  },
  plotOptions: {
    radialBar: {
      offsetY: -10,
      startAngle: 0,
      endAngle: 270,
      hollow: {
        margin: 5,
        size: "30%",
        background: "transparent",
        image: undefined
      },
      dataLabels: {
        name: {
          show: false
        },
        value: {
          show: false
        }
      }
    }
  },
  colors: ["#1ab7ea", "#0084ff", "#39539E", "#0077B5"],
  series: [76, 67, 61, 90],
  labels: ["Vimeo", "Messenger", "Facebook", "LinkedIn"],
  legend: {
    show: true,
    floating: true,
    fontSize: "16px",
    position: "left",
    offsetX: 0,
    offsetY: 0,
    labels: {
      useSeriesColors: true
    },
    markers: {
      size: 0
    },
    formatter: function(seriesName, opts) {
      return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
    },
    itemMargin: {
      horizontal: 1
    }
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          show: false
        }
      }
    }
  ]
};

export default {
  studGrowth,
  visitGrowth,
  radialBar,
  getDateMonth,
  barOptions
};
